// extracted by mini-css-extract-plugin
export default {"wrapperClass":"tDmbKT3v8PPuwXo7jHeF"};